import Flex from '@Components/Bases/Flex';
import FormCheckbox from '@Components/Form/FormCheckBox';
import { defaultCompletedSection } from '@Domains/utils';
import { Divider, Typography } from '@mui/material';
import { formatToShortThaiDateTime } from '@Utils/datetime';
import { CompleteSectionFormValues } from '@Utils/Types/FormValuesTypes';
import { useFormContext, useWatch } from 'react-hook-form';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { IGreenhouseStandardFormValues } from '../EsgGreenhouseFormProvider/types';
import {
  checkPrincipleCompletionEn,
  checkPrincipleCompletionTh,
} from './utils';
import { resetCompletedSection } from '@Utils/updateCompletedSection';

const GreenhouseCompletedCheckbox = () => {
  const { isPublished } = useProgressBar();
  const greenhouseStandard = useWatch({
    name: 'greenhouseStandard',
  }) as IGreenhouseStandardFormValues;
  const { setValue } = useFormContext();

  const principles = greenhouseStandard?.principles ?? {};
  const remark = greenhouseStandard?.remark ?? {};

  const completedSection =
    (useWatch({
      name: 'greenhouseStandard.completedSection',
    }) as CompleteSectionFormValues) || defaultCompletedSection;
  const {
    isCompletedTh,
    isCompletedEn,
    dateTh,
    dateEn,
    roleStampTh,
    roleStampEn,
  } = completedSection;

  const formattedCompletedSectionDateTh = dateTh
    ? formatToShortThaiDateTime(dateTh)
    : '';
  const formattedCompletedSectionDateEn = dateEn
    ? formatToShortThaiDateTime(dateEn)
    : '';

  const isCompleteTh = checkPrincipleCompletionTh(principles, remark);
  const isCompleteEn = checkPrincipleCompletionEn(principles, remark);

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    language: 'Th' | 'En'
  ) => {
    const updatedSection = { ...completedSection };

    if (language === 'Th') {
      updatedSection.isCompletedTh = e.target.checked;
    } else {
      updatedSection.isCompletedEn = e.target.checked;
    }

    resetCompletedSection(updatedSection, setValue, 'greenhouseStandard');
  };

  return (
    <>
      <Divider />
      <Flex gap={4} justifyContent={'center'} bgcolor={'grey.50'} py={1}>
        <Flex alignItems={'center'}>
          <Typography fontWeight={800} textAlign={'right'}>
            ยืนยันการตรวจสอบข้อมูลครบถ้วน
          </Typography>
        </Flex>
        <Flex>
          <Flex flexDirection="column" alignItems={'center'}>
            <FormCheckbox
              name="greenhouseStandard.completedSection.isCompletedTh"
              label="จัดเตรียมข้อมูลเรียบร้อย (ภาษาไทย)"
              inputProps={{ disabled: isPublished || !isCompleteTh }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleCheckboxChange(e, 'Th')
              }
            />
            {isCompletedTh && dateTh && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ display: 'block' }}
              >
                โดย {roleStampTh} {formattedCompletedSectionDateTh}
              </Typography>
            )}
          </Flex>

          <Flex flexDirection="column" alignItems={'center'}>
            <FormCheckbox
              sx={{ ml: 2 }}
              name="greenhouseStandard.completedSection.isCompletedEn"
              label="จัดเตรียมข้อมูลเรียบร้อย (ภาษาอังกฤษ)"
              inputProps={{ disabled: isPublished || !isCompleteEn }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleCheckboxChange(e, 'En')
              }
            />
            {isCompletedEn && dateEn && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ display: 'block' }}
              >
                โดย {roleStampEn} {formattedCompletedSectionDateEn}
              </Typography>
            )}
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default GreenhouseCompletedCheckbox;
